import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import { BcStateContext } from '@bayclubs/state';

import {
    BlockedSlotEventDetailsModel,
    GroupClassEventDetailsModel,
    CourtBookingEventDetailsModel
} from '@bayclubs/court-booking-employee-api';

import { CourtEventDetailsSelectors } from './court-event-details.selectors';
import * as actions from './court-event-details.actions';

@Injectable({ providedIn: 'root' })
export class CourtEventDetailsFacade {
    @Select(CourtEventDetailsSelectors.blockedSlotDetails) blockedSlotDetails$: Observable<
        BcStateContext<BlockedSlotEventDetailsModel>
    >;
    @Select(CourtEventDetailsSelectors.courtClassDetails) courtClassDetails$: Observable<
        BcStateContext<GroupClassEventDetailsModel>
    >;
    @Select(CourtEventDetailsSelectors.courtBookingDetails) courtBookingDetails$: Observable<
        BcStateContext<CourtBookingEventDetailsModel>
    >;
    constructor(private store: Store) {}

    getCourtBookingDetailsSnapshot = () => this.store.selectSnapshot(CourtEventDetailsSelectors.courtBookingDetails);
    getBlockedSlotDetailsSnapshot = () => this.store.selectSnapshot(CourtEventDetailsSelectors.blockedSlotDetails);

    loadBlockedSlotDetails = (courtEventId: string) =>
        this.store.dispatch(new actions.LoadBlockedSlotDetailsAction(courtEventId));

    clearLoadedBlockedSlotDetails = () => this.store.dispatch(new actions.ClearLoadedBlockedSlotDetailsAction());

    loadCourtClassDetails = (courtEventId: string) =>
        this.store.dispatch(new actions.LoadCourtClassDetailsAction(courtEventId));

    clearLoadedCourtClassDetails = () => this.store.dispatch(new actions.ClearLoadedCourtClassDetailsAction());

    loadCourtBookingDetails = (courtEventId: string) =>
        this.store.dispatch(new actions.LoadCourtBookingDetailsAction(courtEventId));

    clearLoadedCourtBookingDetails = () => this.store.dispatch(new actions.ClearLoadedCourtBookingDetailsAction());

    noShowAllCourtBooking = (courtEventId: string) =>
        this.store.dispatch(new actions.NoShowAllCourtBookingDetailsAction(courtEventId));

    checkInAllCourtBooking = (courtEventId: string) =>
        this.store.dispatch(new actions.CheckInAllCourtBookingDetailsAction(courtEventId));

    checkInPlayerCourtBooking = (courtEventId: string, personId: string) =>
        this.store.dispatch(new actions.CheckInPlayerCourtBookingDetailsAction(courtEventId, personId));
}
